// extracted by mini-css-extract-plugin
export default {"richTextEditorWrapper":"RichTextEditor_richTextEditorWrapper__Il6JL","editor":"RichTextEditor_editor__yOE61"};